import { apiConfig } from "../apiConfig"
import useFetchClient from "./useFetchClient"
import { DeactivatedEmployee, EmployeeReadyForDeactivation } from "../redux/types";
import { useAppDispatch } from "../redux/hooks";
import { 
    deactivatedEmployeesFetched, 
    deactivatedEmployeesFetchFailure, 
    employeesDeactivated, 
    employeesDeactivationFailure, 
    loading, 
    pendingEmployeesFetched, 
    pendingEmployeesFetchFailure 
} from "../redux/slices/employeeDeactivationSlice";

const useEmployeeDeactivationActions = () => {
    const fetchClient = useFetchClient()
    const dispatch = useAppDispatch()

    const getPendingEmployees = () => {
        dispatch(loading())

        return fetchClient.get(apiConfig.routes.employeeDeactivation)
            .then(response => {
                dispatch(pendingEmployeesFetched(response.data as EmployeeReadyForDeactivation[]))
            })
            .catch(error => {
                console.log('getPendingEmployees error:', error)
                dispatch(pendingEmployeesFetchFailure(error))
            })
    }

    const deactivateEmployees = (employees: EmployeeReadyForDeactivation[]) => {
        dispatch(loading())

        var body = { ids: employees.map((employee) => employee.id )}

        return fetchClient.post(apiConfig.routes.employeeDeactivation, body)
            .then(response => {
                dispatch(employeesDeactivated())
                getPendingEmployees()
                getDeactivatedEmployees()
            })
            .catch(error => {
                console.log('deactivateEmployees error:', error)
                dispatch(employeesDeactivationFailure(error))
            })
    }

    const getDeactivatedEmployees = () => {
        dispatch(loading())

        return fetchClient.get(apiConfig.routes.employeeDeactivationHistory)
            .then(response => {
                dispatch(deactivatedEmployeesFetched(response.data as DeactivatedEmployee[]))
            })
            .catch(error => {
                console.log('getDeactivatedEmployees error:', error)
                dispatch(deactivatedEmployeesFetchFailure(error))
            })
    }

    return {
        getPendingEmployees,
        deactivateEmployees,
        getDeactivatedEmployees
    }
}

export default useEmployeeDeactivationActions
